import React, { useEffect, useState } from "react";
import { Modal, Row, Col, notification, Button, Skeleton } from "antd";
import moment from "moment";
import axios from "axios";

const confirm = Modal.confirm;
const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const ModalRelatorio = ({ id, visible, onCancel, onDelete }) => {
    const [relatorio, setRelatorio] = useState({
        nome_aluno: "",
        data_nascimento: moment(),
        ano_serie: "",
        periodo_atendimento_aee: "",
        professor_aee: "",
        diagnostico_clinica: "",
        frequencia_sessoes: "",
        escola_regular: "",
        sala_recurso: "",
        objetivos_aee: "",
        recursos_estrategias: "",
        observacoes_desempenho: "",
        encaminhamentos_sugestoes: ""
    });
    const [isLoading, setIsLoading] = useState(false);

    const carregarDetalhe = id => {
        setIsLoading(true);

        axios({
            method: "get",
            url: "/api/atendimento/carregar-relatorio-individual",
            params: {
                id
            }
        })
            .then(response => {
                setRelatorio(response.data);
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response.data || "Ocorreu um erro ao carregar o detalhe do relatório.");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const validarExcluirRelatorio = () => {
        confirm({
            title: "Pretende remover este relatório?",
            okText: "Confirmar",
            okType: "Cancelar",
            onOk: () => {
                excluirRelatorio();
            }
        });
    };

    const excluirRelatorio = () => {
        axios({
            method: "put",
            url: "/api/atendimento/excluir-relatorio-individual",
            params: {
                id
            }
        })
            .then(() => {
                openNotificationWithIcon("success", "Relatório removido", "O relatório foi removido com sucesso.");
                onDelete();
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response.data || "Ocorreu um erro ao excluir o relatório.");
            });
    };

    useEffect(() => {
        if (id && visible) carregarDetalhe(id);
    }, [id]);

    return (
        <Modal
            title="Relatório Individual"
            className="modal-detalhe-info"
            visible={visible}
            onCancel={onCancel}
            footer={[
                <Button key="cancelar" onClick={onCancel}>
                    Cancelar
                </Button>,
                <Button key="eliminar" className="modal-detalhe-info-delete-btn" type="danger" onClick={validarExcluirRelatorio}>
                    Excluir Relatório
                </Button>
            ]}
            centered
            width={800}
            bodyStyle={{
                maxHeight: "60vh",
                overflowY: "auto"
            }}
        >
            <div className="modal-detalhe-info__body">
                <div className="modal-detalhe-info__section">
                    <Row gutter={16} style={{ marginBottom: 16 }}>
                        <Col span={12}>
                            <span className="field-label">Nome do aluno</span>
                            <Skeleton loading={isLoading} paragraph={false} active width={30} className="field-skeleton">
                                <p className="field-value">{relatorio.nome_aluno || "-"}</p>
                            </Skeleton>
                        </Col>
                        <Col span={12}>
                            <span className="field-label">Data de Nascimento</span>
                            <Skeleton loading={isLoading} paragraph={false} active width={30} className="field-skeleton">
                                <p className="field-value">{relatorio.data_nascimento || "-"}</p>
                            </Skeleton>
                        </Col>
                        <Col span={12}>
                            <span className="field-label">Ano/Série</span>
                            <Skeleton loading={isLoading} paragraph={false} active width={30} className="field-skeleton">
                                <p className="field-value">{relatorio.ano_serie || "-"}</p>
                            </Skeleton>
                        </Col>
                        <Col span={12}>
                            <span className="field-label">Período de atendimento no AEE</span>
                            <Skeleton loading={isLoading} paragraph={false} active width={30} className="field-skeleton">
                                <p className="field-value">{relatorio.periodo_atendimento_aee || "-"}</p>
                            </Skeleton>
                        </Col>
                        <Col span={12}>
                            <span className="field-label">Professor(a) de AEE responsável</span>
                            <Skeleton loading={isLoading} paragraph={false} active width={30} className="field-skeleton">
                                <p className="field-value">{relatorio.professor_aee || "-"}</p>
                            </Skeleton>
                        </Col>
                        <Col span={12}>
                            <span className="field-label">Diagnóstico/Conduta clínica (se houver)</span>
                            <Skeleton loading={isLoading} paragraph={false} active width={30} className="field-skeleton">
                                <p className="field-value">{relatorio.diagnostico_clinica || "-"}</p>
                            </Skeleton>
                        </Col>
                        <Col span={12}>
                            <span className="field-label">Frequência nas Sessões</span>
                            <Skeleton loading={isLoading} paragraph={false} active width={30} className="field-skeleton">
                                <p className="field-value">{relatorio.frequencia_sessoes || "-"}</p>
                            </Skeleton>
                        </Col>
                        <Col span={12}>
                            <span className="field-label">Escola Regular</span>
                            <Skeleton loading={isLoading} paragraph={false} active width={30} className="field-skeleton">
                                <p className="field-value">{relatorio.escola_regular || "-"}</p>
                            </Skeleton>
                        </Col>
                        <Col span={12}>
                            <span className="field-label">Sala de Recurso</span>
                            <Skeleton loading={isLoading} paragraph={false} active width={30} className="field-skeleton">
                                <p className="field-value">{relatorio.sala_recurso || "-"}</p>
                            </Skeleton>
                        </Col>
                    </Row>
                </div>
                <div className="modal-detalhe-info__section">
                    <h3 style={{ marginTop: 16 }} className="modal-detalhe-info__section-title">
                        1. Objetivos do AEE
                    </h3>
                    <Row gutter={16}>
                        <Col span={24}>
                            <Skeleton loading={isLoading} title={false} active width={30} className="field-skeleton">
                                <p className="field-value--wide">{relatorio.objetivos_aee || "-"}</p>
                            </Skeleton>
                        </Col>
                    </Row>
                </div>
                <div className="modal-detalhe-info__section">
                    <h3 style={{ marginTop: 16 }} className="modal-detalhe-info__section-title">
                        2. Recursos e estratégias utilizados
                    </h3>
                    <Row gutter={16}>
                        <Col span={24}>
                            <Skeleton loading={isLoading} title={false} active width={30} className="field-skeleton">
                                <p className="field-value--wide">{relatorio.recursos_estrategias || "-"}</p>
                            </Skeleton>
                        </Col>
                    </Row>
                </div>
                <div className="modal-detalhe-info__section">
                    <h3 style={{ marginTop: 16 }} className="modal-detalhe-info__section-title">
                        3. Observações sobre o desempenho
                    </h3>
                    <Row gutter={16}>
                        <Col span={24}>
                            <Skeleton loading={isLoading} title={false} active width={30} className="field-skeleton">
                                <p className="field-value--wide">{relatorio.observacoes_desempenho || "-"}</p>
                            </Skeleton>
                        </Col>
                    </Row>
                </div>
                <div className="modal-detalhe-info__section">
                    <h3 style={{ marginTop: 16 }} className="modal-detalhe-info__section-title">
                        4. Encaminhamentos e sugestões
                    </h3>
                    <Row gutter={16}>
                        <Col span={24}>
                            <Skeleton loading={isLoading} title={false} active width={30} className="field-skeleton">
                                <p className="field-value--wide">{relatorio.encaminhamentos_sugestoes || "-"}</p>
                            </Skeleton>
                        </Col>
                    </Row>
                </div>
            </div>
        </Modal>
    );
};

export default ModalRelatorio;
